<template>
	<el-form-item label="占位内容">
		<el-input v-model="data.options.placeholder" />
	</el-form-item>

	<el-form-item label="默认值">
		<el-input v-model="data.options.defaultValue" type="textarea" />
	</el-form-item>

	<el-form-item label="最大长度">
		<el-input-number v-model="data.options.maxlength" :min="0" />
	</el-form-item>

	<el-form-item label="输入框行数">
		<el-input-number v-model="data.options.rows" :min="1" />
	</el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
	name: 'ItemTextarea',
	props: {
		active: {
			type: Object,
			default: null
		}
	},
	emits: ['update:active'],
	setup(props, context) {
		const data = ref(props.active)
		watch(data, val => context.emit('update:active', val), { deep: true })

		return {
			data
		}
	}
})
</script>
